/* eslint-disable import/no-cycle */
import React from 'react';
import DOMPurify from 'dompurify';

import { BaseMessage } from '../index';
import { MessageParamsInput } from '../MessageParams';
import { MessageTypes } from '../../constants';

class TextMessage extends BaseMessage {

  constructor(messageParams: MessageParamsInput) {
    super(messageParams);
    this.renderText = this.renderText.bind(this);
  }

  renderText(TextNode: keyof JSX.IntrinsicElements | React.ComponentType<{dangerouslySetInnerHTML: { __html: string }}>) {
    /* узкое место, т.к при тайпинге срабатывает рендеринг всех сообщений, т.к меняется message в MessageInputArea,
        из-за того что у оператора message нужно хранить в сторе, при изменении перерендеривается Room
      При отправке сообщения происходит 3 рендера:
      1 - меняется message, было сообщение стало тустая строка;
      2 - добавление фейкового сообщения
      3 - когда сообщение пришло с сервера
    */
    if (!this.text) {
      return <TextNode dangerouslySetInnerHTML={{ __html: '' }} />;
    }

    if (this.type === MessageTypes.SYSTEM) {
      return <TextNode dangerouslySetInnerHTML={{ __html: this.text }} />;
    }

    let __html = this.text.replace(/<img\b[^>]*>/gi, match => {
      /* Попробуем найти значение src (в любом регистре, с или без кавычек) */
      const srcMatch = match.match(/\bsrc\s*=\s*(?:"([^"]*)"|'([^']*)'|([^ \t\n\r\f>]+))/i);
      const src = srcMatch?.[1] || srcMatch?.[2] || srcMatch?.[3];
      /* Проверка, что src есть и начинается с допустимого URL */
      const isAllowedSrc = src && src.startsWith(this.serverUrl)
      if (isAllowedSrc) {
        return match
      }
      /* Если нет src или он запрещённый — экранируем <img */
      return match.replace(/<img/i, '&lt;img')
    });
    __html = DOMPurify.sanitize(__html, {
      ADD_ATTR: ['target'], /* для ссылок */
    });
    return (
      <TextNode
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html }}
      />
    );
  }
}

export default TextMessage;
